
import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Autocomplete,
    Typography,
    Paper,
    Grid,
    Chip,
    CircularProgress,
    Alert,
    Divider,
    Card,
    CardContent,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormLabel,
} from "@mui/material";
import { AiOutlinePicture } from "react-icons/ai";
import { toast } from "react-toastify";
import AxiosInstance, { Qandq } from "../../api/AxiosInstance";
import { Stack } from "rsuite";

const genders = [
    { id: 2, label: "Male" },
    { id: 1, label: "Female" },
];

const sendToOptions = [
    { id: "students", label: "Students" },
    { id: "employee", label: "Employees" },
];

const qualificationTypes = [
    { id: "degree", label: "Degree" },
    { id: "masters", label: "Masters" },
];

export default function BrandCampaign() {
    const [user, setUser] = useState(null);
    const [authError, setAuthError] = useState(false);

    useEffect(() => {
        try {
            const user1 = sessionStorage.getItem("user");
            if (!user1) {
                setAuthError(true);
                return;
            }

            const parsedUser = JSON.parse(user1);
            console.log(parsedUser);
            if (!parsedUser.TOKEN || !parsedUser.q_q_users) {
                setAuthError(true);
                return;
            }
            setUser(parsedUser);
        } catch (error) {
            console.error("Failed to parse user data:", error);
            setAuthError(true);
        }
    }, []);

    const [filters, setFilters] = useState({
        gender: "",
        branch_id: [],
        role_id: [],
        qualification_type: "degree",
        degrees_dn: [],
        s_degree_min: "",
        s_degree_yop_min: "",
        s_degree_yop_max: "",
        s_degree_stream: [],
        s_degree_university: [],
        s_degree_college: [],
        s_current_location: [],

    });

    const [message, setMessage] = useState("");
    const [sendTo, setSendTo] = useState("students");
    const [senderName, setSenderName] = useState("Qspiders Family");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const [imagePreview, setImagePreview] = useState("");

    const [branches, setBranches] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const [streams, setStreams] = useState([]);
    const [universities, setUniversities] = useState([]);
    const [colleges, setColleges] = useState([]);
    const [locations, setLocations] = useState([]);
    const [roles, setRoles] = useState([]);

    const [loadingStates, setLoadingStates] = useState({
        branches: false,
        degrees: false,
        streams: false,
        universities: false,
        colleges: false,
        locations: false,
        roles: false,
    });

    const [loadedDropdowns, setLoadedDropdowns] = useState({
        branches: false,
        degrees: false,
        streams: false,
        universities: false,
        colleges: false,
        locations: false,
        roles: false,
    });

    const headers = {
        Authorization: user?.q_q_users
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;
        if (!selectedFile.type.startsWith("image/")) {
            toast.warning("Please select an image file.");
            return;
        }

        setFile(selectedFile);
        const reader = new FileReader();
        reader.onload = () => {
            setImagePreview(reader.result);
        };
        reader.readAsDataURL(selectedFile);
    };

    const handleRemoveFile = () => {
        setFile(null);
        setImagePreview("");
    };

    const fetchBranches = async () => {
        if (loadedDropdowns.branches) return;

        setLoadingStates(prev => ({ ...prev, branches: true }));
        try {
            const response = await Qandq.get("/api/users/get-allbranches?size=500", { headers });
            setBranches(response.data || []);
            setLoadedDropdowns(prev => ({ ...prev, branches: true }));
        } catch (err) {
            console.error("Failed to load branches:", err);
            toast.error("Failed to load branches");
        } finally {
            setLoadingStates(prev => ({ ...prev, branches: false }));
        }
    };

    const fetchDegrees = async (qualificationType) => {
        setLoadingStates(prev => ({ ...prev, degrees: true }));
        try {
            const qualification = qualificationType || filters.qualification_type;
            const response = await Qandq.get(`/api/users/selectdegree?qualification=${qualification}&size=500`, { headers });
            setDegrees(response.data.items || []);
            setLoadedDropdowns(prev => ({ ...prev, degrees: true }));
        } catch (err) {
            console.error("Failed to load degrees:", err);
            toast.error("Failed to load degrees");
        } finally {
            setLoadingStates(prev => ({ ...prev, degrees: false }));
        }
    };

    const fetchStreams = async (qualificationType) => {
        if (loadedDropdowns.streams) return;

        setLoadingStates(prev => ({ ...prev, streams: true }));
        try {
            const qualification = qualificationType || filters.qualification_type;
            const response = await Qandq.get(`/api/users/selectstreams?qualification=${qualification}&size=500`, { headers });
            setStreams(response.data.items || []);
            setLoadedDropdowns(prev => ({ ...prev, streams: true }));
        } catch (err) {
            console.error("Failed to load streams:", err);
            toast.error("Failed to load streams");
        } finally {
            setLoadingStates(prev => ({ ...prev, streams: false }));
        }
    };

    const fetchUniversities = async () => {
        if (loadedDropdowns.universities) return;

        setLoadingStates(prev => ({ ...prev, universities: true }));
        try {
            const response = await Qandq.get("/api/users/get-universities", { headers });
            setUniversities(response.data || []);
            setLoadedDropdowns(prev => ({ ...prev, universities: true }));
        } catch (err) {
            console.error("Failed to load universities:", err);
            toast.error("Failed to load universities");
        } finally {
            setLoadingStates(prev => ({ ...prev, universities: false }));
        }
    };



    const fetchColleges = async (qualificationType, universityId = "") => {
        setLoadingStates(prev => ({ ...prev, colleges: true }));
        try {
            const qualification = qualificationType || filters.qualification_type;
            const response = await Qandq.get(
                `/api/users/selectcollege?name=&qualification=${qualification}&university_id=${universityId}`,
                { headers }
            );
            setColleges(response.data.items || []);
            setLoadedDropdowns(prev => ({ ...prev, colleges: true }));
        } catch (err) {
            console.error("Failed to load colleges:", err);
            toast.error("Failed to load colleges");
        } finally {
            setLoadingStates(prev => ({ ...prev, colleges: false }));
        }
    };

    const fetchLocations = async () => {
        if (loadedDropdowns.locations) return;

        setLoadingStates(prev => ({ ...prev, locations: true }));
        try {
            const response = await Qandq.get("/api/state/states?country=1&size=50", { headers });
            setLocations(response.data.items || []);
            setLoadedDropdowns(prev => ({ ...prev, locations: true }));
        } catch (err) {
            console.error("Failed to load locations:", err);
            toast.error("Failed to load locations");
        } finally {
            setLoadingStates(prev => ({ ...prev, locations: false }));
        }
    };

    const fetchRoles = async () => {
        if (loadedDropdowns.roles) return;

        setLoadingStates(prev => ({ ...prev, roles: true }));
        try {
            const response = await Qandq.get("/api/help/roles?size=150", { headers });
            setRoles(response.data.items || []);
            setLoadedDropdowns(prev => ({ ...prev, roles: true }));
        } catch (err) {
            console.error("Failed to load roles:", err);
            toast.error("Failed to load roles");
        } finally {
            setLoadingStates(prev => ({ ...prev, roles: false }));
        }
    };

    const handleQualificationChange = (e) => {
        const newQualification = e.target.value;
        setFilters({
            ...filters,
            qualification_type: newQualification,
            degrees_dn: [],
            s_degree_college: [],
            s_degree_stream: [],

        });

        setLoadedDropdowns(prev => ({
            ...prev,
            degrees: false,
            colleges: false,
            streams: false
        }));

        setDegrees([]);
        setColleges([]);
        setStreams([])
    };

    const validateFilters = () => {
        if (filters.s_degree_yop_min && filters.s_degree_yop_max) {
            const minYear = parseInt(filters.s_degree_yop_min);
            const maxYear = parseInt(filters.s_degree_yop_max);

            if (isNaN(minYear) || isNaN(maxYear)) {
                toast.error("Year of Passing must be valid numbers");
                return false;
            }

            if (minYear > maxYear) {
                toast.error("YOP From cannot be greater than YOP To");
                return false;
            }

            const currentYear = new Date().getFullYear();
            if (maxYear > currentYear + 5) {
                toast.warning(`YOP To year seems too far in the future (${maxYear})`);
            }
        }

        if (filters.s_degree_min) {
            const percentage = parseFloat(filters.s_degree_min);
            if (isNaN(percentage) || percentage < 0 || percentage > 100) {
                toast.error("Percentage must be between 0 and 100");
                return false;
            }
        }

        return true;
    };

    const getActiveFiltersCount = () => {
        let count = 0;
        if (filters.gender) count++;
        if (filters.branch_id.length > 0) count++;
        if (filters.role_id.length > 0) count++;
        if (filters.degrees_dn.length > 0) count++;
        if (filters.s_degree_min) count++;
        if (filters.s_degree_yop_min || filters.s_degree_yop_max) count++;
        if (filters.s_current_location.length > 0) count++;
        if (filters.s_degree_stream.length > 0) count++;
        if (filters.s_degree_university.length > 0) count++;
        if (filters.s_degree_college.length > 0) count++;
        return count;
    };

    const handleSend = async () => {
        if (!message.trim() && !file) {
            toast.warning("Please enter a message or attach an image");
            return;
        }

        if (message.trim() && message.trim().length < 10) {
            toast.warning("Message is too short. Please write at least 10 characters.");
            return;
        }

        if (!sendTo) {
            toast.warning("Please select who to send the message to");
            return;
        }

        if (!senderName.trim()) {
            toast.warning("Please enter sender name");
            return;
        }

        if (!validateFilters()) {
            return;
        }

        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            const value = filters[key];
            if (Array.isArray(value) && value.length > 0) {
                cleanFilters[key] = value;
            } else if (value && !Array.isArray(value)) {
                cleanFilters[key] = value;
            }
        });

        const messagePayload = {
            text: message.trim(),
            role: "branding",
            senderId: user._id,
            senderName: senderName.trim(),
            contactPerson: "Qspiders",
            sendTo,
            filter_true: getActiveFiltersCount() > 0,
            q_q_token: user?.q_q_users,
        };

        let filesData = null;
        if (file) {
            const uploadPayload = new FormData();
            uploadPayload.append("sender", user._id);
            uploadPayload.append("files", file);

            try {
                const uploadResponse = await AxiosInstance.post(
                    "/chat/newmsgfiles",
                    uploadPayload,
                    {
                        headers: {
                            Authorization: `Bearer ${user?.TOKEN}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                filesData = uploadResponse.data.files;
            } catch (uploadError) {
                console.error("File upload failed:", uploadError);
                const errorMsg = uploadError.response?.data?.message || "File upload failed. Please try again.";
                toast.error(errorMsg);
                setLoading(false);
                return;
            }
        }

        const finalMessage = {
            ...messagePayload,
            file: file ? filesData?.[0] ?? null : null,
        };

        const requestHeaders = {
            Authorization: `Bearer ${user?.TOKEN}`,
            "Content-Type": "application/json",
        };

        const requestData = {
            filters: cleanFilters,
            message: finalMessage,
        };

        console.log("sending payload", requestData);
        let errs = false;
        try {
            setLoading(true);
            await AxiosInstance.post("/brand/newbrandsendmsg", requestData, {
                headers: requestHeaders,
            });
            console.log({ ...finalMessage });
        } catch (err) {
            errs = true;
            console.error("Campaign send error:", err);
            const errorMsg = err.response?.data?.message || "Failed to send campaign. Please try again.";
            toast.error(errorMsg);
        } finally {
            setLoading(false);

            if (!errs) {
                setMessage("");
                setFile(null);
                setImagePreview("");
                handleClearFilters();
                toast.success("🚀 Campaign sent successfully!");
            }
        }
    };

    const handleClearFilters = () => {
        setFilters({
            gender: "",
            branch_id: [],
            role_id: [],
            qualification_type: "degree",
            degrees_dn: [],
            s_degree_min: "",
            s_degree_yop_min: "",
            s_degree_yop_max: "",
            s_degree_stream: [],
            s_degree_university: [],
            s_degree_college: [],
            s_current_location: [],
        });
        // toast.info("Filters cleared");
    };

    if (authError) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">
                    Authentication error. Please log in again.
                </Alert>
            </Box>
        );
    }

    if (!user) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: "auto" }}>
            {error && (
                <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
                    {error}
                </Alert>
            )}

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Card elevation={2}>
                        <CardContent>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                <Typography variant="h6" fontWeight="600">
                                    Filters
                                    {getActiveFiltersCount() > 0 && (
                                        <Chip
                                            label={`${getActiveFiltersCount()} active`}
                                            size="small"
                                            color="primary"
                                            sx={{ ml: 1 }}
                                        />
                                    )}
                                </Typography>
                                {getActiveFiltersCount() > 0 && (
                                    <Button size="small" onClick={handleClearFilters}>
                                        Clear All
                                    </Button>
                                )}
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                {sendTo === "students" && (
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Gender</InputLabel>
                                        <Select
                                            value={filters.gender}
                                            label="Gender"
                                            onChange={(e) => setFilters({ ...filters, gender: e.target.value })}
                                        >
                                            {genders.map(g => (
                                                <MenuItem key={g.id} value={g.id}>{g.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                <Autocomplete
                                    multiple
                                    size="small"
                                    options={branches}
                                    getOptionLabel={(o) => o.name || ""}
                                    value={branches.filter(sendTo === "employee" ? b => filters.branch_id.includes(b.name) : b => filters.branch_id.includes(b.id))}
                                    onChange={(e, v) =>
                                        setFilters({ ...filters, branch_id: sendTo === "employee" ? v.map(x => x.name) : v.map(x => x.id) })
                                    }
                                    onOpen={fetchBranches}
                                    loading={loadingStates.branches}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Branches"
                                            placeholder="Select branches"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loadingStates.branches ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                key={index}
                                                label={option.name}
                                                size="small"
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                />

                                {sendTo === "employee" && (
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        options={roles}
                                        getOptionLabel={(o) => o.name || ""}
                                        value={roles.filter(r => filters.role_id.includes(r.name))}
                                        onChange={(e, v) =>
                                            setFilters({ ...filters, role_id: v.map(x => x.name) })
                                        }
                                        onOpen={fetchRoles}
                                        loading={loadingStates.roles}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Roles"
                                                placeholder="Select roles"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingStates.roles ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option.name}
                                                    size="small"
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                    />
                                )}

                                {sendTo === "students" && (
                                    <>
                                        <Paper sx={{ p: 2, bgcolor: "grey.50" }}>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend" sx={{ mb: 1, fontWeight: 600, fontSize: "0.875rem" }}>
                                                    Qualification Type
                                                </FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={filters.qualification_type}
                                                    onChange={handleQualificationChange}
                                                >
                                                    {qualificationTypes.map(type => (
                                                        <FormControlLabel
                                                            key={type.id}
                                                            value={type.id}
                                                            control={<Radio size="small" />}
                                                            label={type.label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Paper>

                                        <Autocomplete
                                            multiple
                                            size="small"
                                            options={degrees}
                                            getOptionLabel={(o) => o.name || ""}
                                            value={degrees.filter(c => filters.degrees_dn.includes(c.name))}
                                            onChange={(e, v) =>
                                                setFilters({ ...filters, degrees_dn: v.map(x => x.name) })
                                            }
                                            onOpen={() => fetchDegrees(filters.qualification_type)}
                                            loading={loadingStates.degrees}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={`${filters.qualification_type === 'masters' ? 'Masters' : 'Degree'} Name`}
                                                    placeholder={`Select ${filters.qualification_type === 'masters' ? 'Masters' : 'Degree'}`}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingStates.degrees ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option.name}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                        />

                                        <Autocomplete
                                            multiple
                                            size="small"
                                            options={streams}
                                            getOptionLabel={(o) => o.name || ""}
                                            value={streams.filter(s => filters.s_degree_stream.includes(s.name))}
                                            onChange={(e, v) =>
                                                setFilters({ ...filters, s_degree_stream: v.map(x => x.name) })
                                            }
                                            onOpen={() => fetchStreams(filters.qualification_type)}

                                            loading={loadingStates.streams}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={`${filters.qualification_type === 'masters' ? 'Masters' : 'Degree'} streams`}
                                                    placeholder={`Select ${filters.qualification_type === 'masters' ? 'Masters' : 'Degree'}`}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingStates.streams ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option.name}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                        />

                                        <Autocomplete
                                            multiple
                                            size="small"
                                            options={universities}
                                            getOptionLabel={(o) => o.name || ""}
                                            value={universities.filter(u => filters.s_degree_university.includes(u.name))}
                                            onChange={(e, v) =>
                                                setFilters({ ...filters, s_degree_university: v.map(x => x.name) })
                                            }
                                            onOpen={fetchUniversities}
                                            loading={loadingStates.universities}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="University"
                                                    placeholder="Select University"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingStates.universities ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option.name}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                        />

                                        <Autocomplete
                                            multiple
                                            size="small"
                                            options={colleges}
                                            getOptionLabel={(o) => o.name || ""}
                                            value={colleges.filter(c => filters.s_degree_college.includes(c.name))}
                                            onChange={(e, v) =>
                                                setFilters({ ...filters, s_degree_college: v.map(x => x.name) })
                                            }
                                            onOpen={() => fetchColleges(filters.qualification_type)}
                                            loading={loadingStates.colleges}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="College"
                                                    placeholder="Select College"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingStates.colleges ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option.name}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                        />

                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <TextField
                                                size="small"
                                                label="YOP From"
                                                type="number"
                                                fullWidth
                                                value={filters.s_degree_yop_min}
                                                onChange={(e) => setFilters({ ...filters, s_degree_yop_min: e.target.value })}
                                                inputProps={{ min: 2000, max: 2026 }}
                                            />
                                            <TextField
                                                size="small"
                                                label="YOP To"
                                                type="number"
                                                fullWidth
                                                value={filters.s_degree_yop_max}
                                                onChange={(e) => setFilters({ ...filters, s_degree_yop_max: e.target.value })}
                                                inputProps={{ min: 2000, max: 2026 }}
                                            />
                                        </Box>

                                        <TextField
                                            size="small"
                                            label="Minimum Percentage"
                                            type="number"
                                            value={filters.s_degree_min}
                                            onChange={(e) => setFilters({ ...filters, s_degree_min: e.target.value })}
                                            inputProps={{ min: 35, max: 100, step: 0.1 }}
                                            helperText="Enter minimum percentage (35-100)"
                                        />

                                        <Autocomplete
                                            multiple
                                            size="small"
                                            options={locations}
                                            getOptionLabel={(o) => o.name || ""}
                                            value={locations.filter(l => filters.s_current_location.includes(l.id))}
                                            onChange={(e, v) =>
                                                setFilters({ ...filters, s_current_location: v.map(x => x.id) })
                                            }
                                            onOpen={fetchLocations}
                                            loading={loadingStates.locations}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Current Location"
                                                    placeholder="Select state"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loadingStates.locations ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option.name}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                        />
                                    </>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h6" fontWeight="600" mb={2}>
                                Message
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
                                {/* Send To */}
                                <FormControl fullWidth size="small">
                                    <InputLabel>Send To</InputLabel>
                                    <Select
                                        value={sendTo}
                                        label="Send To"
                                        onChange={(e) => {
                                            setSendTo(e.target.value)
                                            if (getActiveFiltersCount() > 0) {
                                                handleClearFilters()
                                            }
                                        }}
                                    >
                                        {sendToOptions.map(option => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                {/* Sender Name */}
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Sender Name"
                                    value={senderName}
                                    onChange={(e) => setSenderName(e.target.value)}
                                    placeholder="Qspiders Family"
                                    helperText="Default: Qspiders Family"
                                />
                            </Box>
                            <TextField
                                fullWidth
                                multiline
                                rows={10}
                                placeholder="Type your broadcast message here...&#10;&#10;Example:&#10;Hey there! 👋&#10;This is a campaign message for our students.&#10;&#10;Best regards,&#10;Team Qspiders"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                variant="outlined"
                                sx={{
                                    mb: 2,
                                    "& .MuiOutlinedInput-root": {
                                        fontFamily: "monospace",
                                    }
                                }}
                                helperText={`${message.length} characters${file ? ` • ${file.name}` : ""}`}
                            />

                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center", mb: 2 }}>
                                <Button
                                    component="label"
                                    startIcon={<AiOutlinePicture />}
                                    variant="outlined"
                                    size="small"
                                >
                                    Send Images
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </Button>

                                {file && (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                        <Box
                                            component="img"
                                            src={imagePreview}
                                            alt="Image preview"
                                            sx={{ width: 100, height: 100, objectFit: "cover", borderRadius: 1, border: "1px solid rgba(0,0,0,0.12)" }}
                                        />
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                            <Typography variant="body2">{file.name}</Typography>
                                            <Button size="small" color="error" variant="text" onClick={handleRemoveFile}>
                                                Remove Image
                                            </Button>
                                        </Box>
                                    </Box>
                                )}
                            </Box>

                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    size="large"
                                    onClick={handleSend}
                                    disabled={loading || (!message.trim() && !file)}
                                >
                                    {loading ? (
                                        <>
                                            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                                            Sending Campaign...
                                        </>
                                    ) : (
                                        "Send Campaign"
                                    )}
                                </Button>
                            </Box>

                            {message.trim() && message.trim().length < 10 && (
                                <Alert severity="warning" sx={{ mt: 2 }}>
                                    Message is too short. Write at least 10 characters.
                                </Alert>
                            )}

                            {/* Campaign Summary */}
                            <Paper sx={{ mt: 1, p: 2, bgcolor: "grey.50" }}>
                                <Typography variant="subtitle2" fontWeight="600" mb={1}>
                                    Summary
                                </Typography>

                                <Stack
                                    direction="row"
                                    spacing={3}
                                    flexWrap="wrap"
                                    alignItems="center"
                                >
                                    <Typography variant="body2" color="text.secondary">
                                        <strong>To:</strong>{" "}
                                        {sendToOptions.find(o => o.id === sendTo)?.label || "Not selected"}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        <strong>From:</strong> {senderName || "Not set"}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        <strong>Filters:</strong> {getActiveFiltersCount()} active
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        <strong>Message Length:</strong> {message.length} characters
                                    </Typography>
                                </Stack>
                            </Paper>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}